import React from 'react';
import { Text, StyleProp, TextStyle } from 'react-native';
import { BaseTextProps } from './BaseText.types';
import { isSafeTextChild } from './BaseText.utils';

export interface SingleBaseTextProps extends BaseTextProps {
  useFontHook: (style: StyleProp<TextStyle> | undefined) => StyleProp<TextStyle> | undefined;
}

export const SingleBaseText = (props: SingleBaseTextProps) => {
  const { useFontHook, style, children, ...rest } = props;
  const fontStyle = useFontHook(style);

  return isSafeTextChild(children) ? (
    <Text {...rest} style={[style, fontStyle]}>
      {children}
    </Text>
  ) : (
    <></>
  );
};
